import { defineAbility } from "@casl/ability";
import store from "@/store/index.js";

export default defineAbility(can => {
  let roles = store.state.auth.roles;
  if (!roles) return;
  roles.forEach(role => {
    can(role.name);
  });
});
